<template>
  <div class="d-inline-block">
    <comment-profile
      class="d-inline-block"
      :profile-id="profile._id"
      :comments-count="profile.comments.length">
    </comment-profile>
    <a style="text-decoration: none" :href="profile.url" target="_blank">
      <v-btn icon class="primary--text">
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </a>
    <edit-profile :profile-id="profile._id"></edit-profile>
  </div>
</template>

<script>
  import CommentProfile from "../Buttons/Profiles/commentProfile";
  import EditProfile from "../Buttons/Profiles/editProfile";

  export default {
    name: "profileActionButtons",
    components: {EditProfile, CommentProfile},
    props: ['profile']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Widgets/profileActionButtons.vue